export default {
      id: "file-usage",
      viewBox: "0 0 256 256",
      url: "/dist/svg/" + "sprite.svg#file-usage",
      toString: function () {
        return this.url;
      }
    }